module.exports = __webpack_public_path__ + "img/alarm_3.svg";